import React from 'react';
import { Dialog } from 'cdk-radial';
import classes from './FortellisTermsOverlay.module.css';

const FortellisTermsOverlay = props => {
  const {
    fortellisTermsAndConditionsData,
    fortellisTermsAndConditionsUpdatedDate
  } = props;

  return (
    <Dialog
      id="dialog-test"
      className={classes.dialog}
      isOpen={props.isOpen}
      closeLabel="Close"
      disableFocusTrap={false}
      hideCloseButton={false}
      hideHeader={false}
      isFullScreen={false}
      onClose={props.isClose}
      renderCustomFooterComponent={null}
      buttonprops=""
      title="Fortellis Terms and Conditions"
    >
      <p>
        Updated:{' '}
        {(fortellisTermsAndConditionsUpdatedDate &&
          fortellisTermsAndConditionsUpdatedDate.indexOf(',') > -1 &&
          fortellisTermsAndConditionsUpdatedDate.split(',')[0]) ||
          ''}
      </p>
      {(fortellisTermsAndConditionsData && fortellisTermsAndConditionsData.map(detail => (
        <p key={detail.key}>{detail.text}</p>
      ))) || null}
    </Dialog>
  );
};

export default FortellisTermsOverlay;